module.exports = __webpack_public_path__ + "img/link.a33fa3d6.svg";